export default __webpack_public_path__ + "static/media/404.8a5aafa6.png";